document.querySelectorAll('.product-popup-modal__page-content table').forEach((table) => {
  if (table.dataset.mobileLabelsReady === 'true') return;

  const headerCells = Array.from(table.querySelectorAll('thead th'));
  let headers = headerCells.map((cell) => cell.textContent.trim()).filter(Boolean);

  if (headers.length === 0) {
    const firstRow = table.querySelector('tr');
    if (!firstRow) return;
    headers = Array.from(firstRow.children)
      .map((cell) => cell.textContent.trim())
      .filter(Boolean);
  }

  const bodyRows = Array.from(table.querySelectorAll('tbody tr'));
  const rows = bodyRows.length > 0 ? bodyRows : Array.from(table.querySelectorAll('tr')).slice(1);

  rows.forEach((row) => {
    Array.from(row.children).forEach((cell, index) => {
      if (index === 0) return;

      const label = headers[index];
      if (label) cell.setAttribute('data-column-label', label);
    });
  });

  table.dataset.mobileLabelsReady = 'true';
});
